export function isValidFloat(value) {
  if (value.startsWith('.')) {
    return false;
  }

  return !isNaN(value);
}
